import { useEffect, useCallback } from 'react';
import tokenStorage from '../utils/tokenStorage';

const INACTIVITY_TIMEOUT = 15 * 60 * 1000;

export const useInactivityManager = (logout) => {
  const resetInactivityTimer = useCallback(() => {
    const existingTimer = window._inactivityTimer;
    if (existingTimer) {
      clearTimeout(existingTimer);
    }

    window._inactivityTimer = setTimeout(() => {
      logout();
    }, INACTIVITY_TIMEOUT);
  }, [logout]);

  const handleUserActivity = useCallback(() => {
    tokenStorage.touchActivity();
    resetInactivityTimer();
  }, [resetInactivityTimer]);

  useEffect(() => {
    const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click', 'keypress'];

    resetInactivityTimer();

    activityEvents.forEach((eventName) => {
      document.addEventListener(eventName, handleUserActivity);
    });

    return () => {
      if (window._inactivityTimer) {
        clearTimeout(window._inactivityTimer);
      }
      activityEvents.forEach((eventName) => {
        document.removeEventListener(eventName, handleUserActivity);
      });
    };
  }, [handleUserActivity, resetInactivityTimer]);
};
